import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import { DateUtils } from 'react-day-picker';

import moment from 'moment-timezone';
import { setTimezone, getDateFromMoment } from '../../../../shared/utils/time';
import { DayPicker, Weekday, Navbar, NavIcon, MonthTitle, Day } from './datePicker.styles';
import { ICON_ARROW_LEFT, ICON_ARROW_RIGHT } from '../../../../shared/components/icon';

const AVAILABLE_DAYS_COUNT = 90;

export class DatePicker extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    activeDate: PropTypes.number,
    firstAvailableDate: PropTypes.instanceOf(moment),
    disabledWeekdays: PropTypes.array,
    experience: PropTypes.object,
    timezone: PropTypes.string,
    onDateSelected: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (!this.props.activeDate) {
      const date = this.props.firstAvailableDate.unix();
      this.props.onDateSelected(date);
    }
  }

  getSelectedDate = () => {
    const { activeDate, timezone } = this.props;
    return moment.unix(activeDate).tz(timezone);
  };

  getLastAvailableDate = () =>
    moment()
      .add(AVAILABLE_DAYS_COUNT, 'days')
      .tz(this.props.timezone);

  formatMonthTitle = date => <FormattedDate value={date} year="numeric" month="long" />;

  handleDayClick = (day, modifiers = {}) => {
    if (modifiers.disabled) {
      return;
    }

    const marketTimezoneDate = setTimezone(moment(day), this.props.timezone);
    this.props.onDateSelected(marketTimezoneDate.unix());
  };

  renderNavbar = ({ month, onPreviousClick, onNextClick, className }) => {
    const { timezone } = this.props;
    const monthWithTimezone = setTimezone(moment(month), timezone);
    const monthTitle = this.formatMonthTitle(month);

    const sameMonth = this.props.firstAvailableDate.isSame(monthWithTimezone, 'month');
    const isLastAvailableDateMonth = this.getLastAvailableDate().isSame(monthWithTimezone, 'month');

    return (
      <Navbar className={className}>
        <NavIcon stroked name={ICON_ARROW_LEFT} onClick={() => onPreviousClick()} inactive={sameMonth} />
        <MonthTitle>{monthTitle}</MonthTitle>
        <NavIcon stroked name={ICON_ARROW_RIGHT} onClick={() => onNextClick()} inactive={isLastAvailableDateMonth} />
      </Navbar>
    );
  };

  renderDay = (day, modifiers) => {
    const { timezone } = this.props;
    const todayInMarket = getDateFromMoment(moment().tz(timezone));
    modifiers.today = DateUtils.isSameDay(day, todayInMarket);

    return (
      <ThemeProvider theme={modifiers}>
        <Day {...modifiers}>{day.getDate()}</Day>
      </ThemeProvider>
    );
  };

  renderWeekday = ({ weekday, className }) => {
    const value = getDateFromMoment(moment().day(weekday));
    return (
      <Weekday className={className}>
        <FormattedDate value={value} weekday="short" />
      </Weekday>
    );
  };

  render() {
    const disabledDays = [
      { daysOfWeek: this.props.disabledWeekdays },
      { before: getDateFromMoment(this.props.firstAvailableDate) },
      {
        after: getDateFromMoment(this.getLastAvailableDate()),
      },
    ];

    const selectedDay = getDateFromMoment(this.getSelectedDate());

    return (
      <DayPicker
        className={this.props.className}
        onDayClick={this.handleDayClick}
        selectedDays={selectedDay}
        firstDayOfWeek={1}
        weekdayElement={this.renderWeekday}
        navbarElement={this.renderNavbar}
        captionElement={<></>}
        renderDay={this.renderDay}
        disabledDays={disabledDays}
        month={selectedDay}
      />
    );
  }
}
